"use client"
 import PlusSigns from "../../public/assets/plus-pattern-long.svg"

export default function FormSection() {
return (
    <section className="bg-warm-white text-blue-dark pt-60 pb-10 lg:py-20 overflow-x-hidden">
        <div className="container grid grid-cols-1 lg:grid-cols-2 gap-10 relative">
          <div className="grid grid-cols-1 gap-5 place-content-start">
            <h2>Brand Guidelines & Creative Assets</h2>
            <p>
              To ensure your ad creative best represents your brand, we'll need a few things from you:
            </p>
            <ul className="list-disc pl-5">
              <li>
                <strong>Your logo(s),</strong>  all variations if possible. Preferred formats: vector (.ai, .eps, .svg, .pdf) or high quality transparent background (.psd, .tiff, .png).
              </li>
              <li>
                <strong>Your brand guidelines</strong> or brand direction.
              </li>
              <li>
                <strong>Links</strong> to your website, landing pages, social media or other resources that represent your brand.
              </li>
              <li>
                <strong>Design direction</strong>, style preferences, colors to avoid, industry no-nos,  or key design details to guide our work.
              </li>
            </ul>
          </div>
          <div id="form" className="bg-white rounded-[32px] shadow-card px-1 py-8 lg:p-10 relative z-20">
            <iframe
              width="100%"
              height="800"
              src="https://www.wrike.com/form/eyJhY2NvdW50SWQiOjU3MDY1NTAsInRhc2tGb3JtSWQiOjIzNTY0NzN9CTQ5MTkwNjg1OTY4NDMJMzhkYmE0MDU2NGE4OWY0ODMyZTM2N2E3NTczMjRjMTM2YzVkYjZkMzA2MGUwYmQ4YWE5ZmVlM2ZlOGZhMWFlYQ=="
            ></iframe>
          </div>
          <PlusSigns className="absolute -right-20 top-1/3 text-green-lime hidden lg:block" />
        </div>
      </section>
  )
}